<div class="pb-4">
  <div class="d-flex gap-4 mb-4">
    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [removeExpandedClass]="true"
      [title]="'tkey;teams_call_queue.settings.header'"
      [icon]="ziroIcons.GEAR_COMPLEX"
      [class]="'col'"
      [isCollapsible]="false"
    >
      <ziro-text [fieldId]="'name'" [inlineLabel]="false"></ziro-text>
      <ziro-select [fieldId]="'language'" [inlineLabel]="false"></ziro-select>
      <ziro-select [fieldId]="'routingMethod'" [inlineLabel]="false"></ziro-select>
      <ziro-text [fieldId]="'agentAlertTime'" [inlineLabel]="false"></ziro-text>
      <ziro-checkbox [fieldId]="'conferenceMode'"></ziro-checkbox>
      <ziro-checkbox [fieldId]="'presenceAwareRouting'"></ziro-checkbox>
      <ziro-checkbox [fieldId]="'allowOptOut'"></ziro-checkbox>
    </ziro-collapsible-section-card>

    @if (!is360ViewChild) {
      <!-- RESOURCE ACCOUNTS -->
      <ziro-collapsible-section-card
        [isSwitchHidden]="true"
        [removeExpandedClass]="true"
        [title]="'tkey;teams_call_queue.resource_accounts.header'"
        [icon]="ziroIcons.PHONE_LIST"
        [class]="'col'"
        [isCollapsible]="false"
      >
        <div
          class="card-body pt-4 pb-0 d-flex flex-column resource-body overflow-scroll"
          data-automation="resource-accounts"
        >
          <ng-template #invalidTooltip>
            <span>{{ 'tkey;teams_call_queue.invalid.tooltip' | translate: { type: resourceAccountType } }}</span>
          </ng-template>
          <div>
            <label class="card-title mb-1">{{ 'tkey;teams_call_queue.resource_accounts.header' | translate }}</label>
            <ul class="list-style-type-none p-0">
              @for (resourceAccount of callQueueView()().resourceAccounts; track resourceAccount.upn) {
                <li>
                  <div class="card mb-3 px-4 d-flex align-items-center flex-row justify-content-between">
                    <div class="d-flex gap-2 py-2">
                      <div
                        data-automation="invalid-tooltip"
                        class="d-flex align-items-center"
                        [ngbTooltip]="invalidTooltip"
                        [disableTooltip]="resourceAccount.status === MicrosoftTeamsCallQueueViewEntityStatus.VALID"
                      >
                        @if (resourceAccount.status === MicrosoftTeamsCallQueueViewEntityStatus.GUID_NOT_FOUND) {
                          <i [class]="`${ZiroIcons.WARNING_TRIANGLE} text-warning me-1`"></i>
                        }
                        <span [class]="'initials initials-letterspacing-2'">
                          <strong>{{ getUserInitialsFromDisplayName(resourceAccount.displayName) }}</strong>
                        </span>
                      </div>
                      <div class="flex-grow-1 d-flex flex-column justify-content-center">
                        <p class="mb-0">
                          <strong>{{ resourceAccount.displayName }}</strong>
                          |
                          <span data-automation="upn">{{ resourceAccount.upn }}</span>
                        </p>
                        <p class="card-text">
                          <strong>{{ resourceAccount.lineUri | telephoneNumberFilter }}</strong>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <button
                        data-automation="delete-resource-account"
                        [class]="'btn-close close-button'"
                        (click)="deleteResourceAccount(resourceAccount, 'resourceAccountGuids', 'resourceAccounts')"
                      ></button>
                    </div>
                  </div>
                </li>
              }
            </ul>
            <div class="w-100" #resourceButton>
              <ziro-button
                [dataAutomation]="'add-resource-account'"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                [label]="'tkey;teams_call_queue.resource_accounts.add.resource_account'"
                [icon]="ziroIcons.PLUS"
                [isFullWidth]="true"
                [cssClass]="'mb-4'"
                (click)="resourceAccountsPopover.toggle($event)"
              ></ziro-button>
            </div>
          </div>
          <p-popover
            #resourceAccountsPopover
            [styleClass]="'resource-popover'"
            (onHide)="onPopoverClose(resourceAccountsInput)"
            (onShow)="onRaPopoverOpen()"
          >
            <div
              #resourceAccountsPopoverContainer
              class="p-4 fit-content"
              data-automation="resource-account-search-popover"
            >
              <label class="w-100 typeahead-search input-group">
                <input
                  #resourceAccountsInput
                  [attr.data-automation]="'ra-type-ahead'"
                  [class]="'w-100 form-control'"
                  [ngClass]="{
                    pending: isSearching,
                  }"
                  [type]="'text'"
                  [ngbTypeahead]="resourceAccountsSearch"
                  [placeholder]="'tkey;teams_call_queue.resource_accounts.resource_search.placeholder' | translate"
                  [focusFirst]="true"
                  (selectItem)="addResourceAccount($event.item, 'resourceAccountGuids', 'resourceAccounts')"
                  [resultFormatter]="resourceAccountFormatter"
                  [resultTemplate]="resourceAccountResult"
                  [popupClass]="'resource-accounts-custom-typeahead'"
                />
                @if (isSearching) {
                  <i class="{{ ziroIcons.SAVING }} icon-warning fa-sm"></i>
                }
              </label>
              <div class="small form-text text-muted mt-1">
                {{ 'tkey;teams_call_queue.resource_accounts.resource_search' | translate }}
              </div>
            </div>
          </p-popover>

          <!-- CALLING ID RESOURCE ACCOUNTS -->
          <div data-automation="calling-id-resource-accounts">
            <label class="card-title mb-1">
              {{ 'tkey;teams_call_queue.calling_id_resource_accounts.header' | translate }}
            </label>
            <ul class="list-style-type-none p-0">
              @for (
                callingIdResourceAccount of callQueueView()().callingIdResourceAccounts;
                track callingIdResourceAccount.upn
              ) {
                <li>
                  <div class="card mb-3 px-4 d-flex align-items-center flex-row justify-content-between">
                    <div class="d-flex gap-2 py-2">
                      <div
                        data-automation="invalid-tooltip"
                        class="d-flex align-items-center"
                        [ngbTooltip]="invalidTooltip"
                        [disableTooltip]="
                          callingIdResourceAccount.status === MicrosoftTeamsCallQueueViewEntityStatus.VALID
                        "
                      >
                        @if (
                          callingIdResourceAccount.status === MicrosoftTeamsCallQueueViewEntityStatus.GUID_NOT_FOUND
                        ) {
                          <i [class]="`${ZiroIcons.WARNING_TRIANGLE} text-warning me-1`"></i>
                        }
                        <span [class]="'initials initials-letterspacing-2'">
                          <strong>{{ getUserInitialsFromDisplayName(callingIdResourceAccount.displayName) }}</strong>
                        </span>
                      </div>
                      <div class="flex-grow-1 d-flex flex-column justify-content-center">
                        <p class="mb-0">
                          <strong>{{ callingIdResourceAccount.displayName }}</strong>
                          |
                          <span data-automation="upn">{{ callingIdResourceAccount.upn }}</span>
                        </p>
                        <p class="card-text">
                          <strong>{{ callingIdResourceAccount.lineUri | telephoneNumberFilter }}</strong>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <button
                        data-automation="delete-resource-account"
                        [class]="'btn-close close-button'"
                        (click)="
                          deleteResourceAccount(
                            callingIdResourceAccount,
                            'callingIdResourceAccountGuids',
                            'callingIdResourceAccounts'
                          )
                        "
                      ></button>
                    </div>
                  </div>
                </li>
              }
            </ul>
            <div class="w-100" #callingIdButton>
              <ziro-button
                [dataAutomation]="'add-resource-account'"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                [label]="'tkey;teams_call_queue.resource_accounts.add.calling_id'"
                [icon]="ziroIcons.PLUS"
                [isFullWidth]="true"
                [cssClass]="'mb-4'"
                (click)="callingIdResourceAccountsPopover.toggle($event)"
              ></ziro-button>
            </div>
          </div>
        </div>
        <p-popover
          #callingIdResourceAccountsPopover
          [styleClass]="'resource-popover'"
          (onHide)="onPopoverClose(callingIdResourceAccountsInput)"
          (onShow)="onCallingIdPopoverOpen()"
        >
          <div
            #callingIdResourceAccountsPopoverContainer
            class="p-4 fit-content"
            data-automation="resource-account-search-popover"
          >
            <label class="w-100 typeahead-search input-group">
              <input
                #callingIdResourceAccountsInput
                [attr.data-automation]="'calling-id-type-ahead'"
                [class]="'w-100 form-control'"
                [ngClass]="{
                  pending: isSearching,
                }"
                [type]="'text'"
                [ngbTypeahead]="callingIdResourceAccountsSearch"
                [placeholder]="'tkey;teams_call_queue.resource_accounts.resource_search.placeholder' | translate"
                [focusFirst]="true"
                (selectItem)="
                  addResourceAccount($event.item, 'callingIdResourceAccountGuids', 'callingIdResourceAccounts')
                "
                [resultFormatter]="resourceAccountFormatter"
                [resultTemplate]="callingIdResourceAccountResult"
                [popupClass]="'resource-accounts-custom-typeahead'"
              />
              @if (isSearching) {
                <i class="{{ ziroIcons.SAVING }} icon-warning fa-sm"></i>
              }
            </label>
            <div class="small form-text text-muted mt-1">
              {{ 'tkey;teams_call_queue.resource_accounts.resource_search' | translate }}
            </div>
          </div>
        </p-popover>
      </ziro-collapsible-section-card>
    }
  </div>

  <!-- GREETINGS -->
  @if (isAudioLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-audio-form [entity]="entity.audioSettings" (ziroFormsUpdate$)="setAudioSetting($event)"></ziro-audio-form>
  }

  <!-- AGENTS -->

  <ziro-agents-card
    [callQueueViewSource]="callQueueViewSource()"
    (agentSelectionChanged)="setAgentSelection($event)"
  ></ziro-agents-card>

  <!-- Callbacks -->
  <ziro-collapsible-section-card
    [dataAutomation]="'callback-settings-card'"
    [title]="'tkey;teams_call_queue.callbacks.header'"
    [icon]="ziroIcons.PHONE_DIAL"
    [class]="'col'"
    [switchId]="'callbackSettingsEnabled'"
    [isOpenInput]="!!entity.callbackSettings?.enabled"
    [isDisabled]="!entity.conferenceMode"
    [disabledTooltip]="'tkey;teams_call_queue.callbacks.disabled.tooltip'"
    (toggleSwitch)="onCallbackSettingsToggled($event)"
  >
    <ziro-callback-settings-form
      [entity]="entity.callbackSettings"
      (ziroFormsUpdate$)="setCallbackSettings($event)"
    ></ziro-callback-settings-form>
  </ziro-collapsible-section-card>

  <!-- EXCEPTION HANDLING -->
  <ziro-collapsible-section-card
    [isSwitchHidden]="true"
    [removeExpandedClass]="true"
    [title]="'tkey;teams_call_queue.exception_handling.header'"
    [subtext]="getExceptionHandlingSubtext()"
    [icon]="ziroIcons.CIRCLE_EXCLAMATION"
    [isCollapsible]="false"
    [cssClass]="'mt-4'"
  >
    <div class="p-4">
      <ul
        ngbNav
        #exceptionNav="ngbNav"
        [destroyOnHide]="false"
        [(activeId)]="activeExceptionTab"
        class="nav-pills"
        data-automation="exception-handling-nav-tabs"
      >
        <li [ngbNavItem]="ExceptionHandlingSectionType.OVERFLOW" [destroyOnHide]="false" class="col-4">
          <a ngbNavLink class="btn nav-link text-center" data-automation="exception-handling-overflow-tab">
            @if (
              exceptionTabsValidationState[ExceptionHandlingSectionType.OVERFLOW]() === ZiroFormsValidationState.INVALID
            ) {
              <i [class]="ZiroIcons.EXCLAMATION + ' fa fa-md icon-exclamation text-danger'"></i>
            }
            <span>{{ 'tkey;teams_call_queue.exception_handling.overflow.header' | translate }}</span>
          </a>
          <ng-template ngbNavContent>
            <ziro-call-queue-exception-handling-form
              #overflowForm
              [dataAutomation]="'call-queue-overflow-handling'"
              [sectionType]="ExceptionHandlingSectionType.OVERFLOW"
              [tenantId]="callQueueViewSource().tenantId.toString()"
              [agentAlertTime]="formData.agentAlertTime"
              [entity]="entity.uiOverflowSettings"
              (ziroFormsUpdate$)="setExceptionHandlingSettings($event, 'uiOverflowSettings')"
            ></ziro-call-queue-exception-handling-form>
          </ng-template>
        </li>
        <li [ngbNavItem]="ExceptionHandlingSectionType.TIMEOUT" [destroyOnHide]="false" class="col-4">
          <a ngbNavLink class="btn nav-link text-center" data-automation="exception-handling-timeout-tab">
            @if (
              exceptionTabsValidationState[ExceptionHandlingSectionType.TIMEOUT]() === ZiroFormsValidationState.INVALID
            ) {
              <i [class]="ZiroIcons.EXCLAMATION + ' fa fa-md icon-exclamation text-danger'"></i>
            }
            <span>{{ 'tkey;teams_call_queue.exception_handling.timeout.header' | translate }}</span>
          </a>
          <ng-template ngbNavContent>
            <ziro-call-queue-exception-handling-form
              #timeoutForm
              [dataAutomation]="'call-queue-timeout-handling'"
              [sectionType]="ExceptionHandlingSectionType.TIMEOUT"
              [tenantId]="callQueueViewSource().tenantId.toString()"
              [agentAlertTime]="formData.agentAlertTime"
              [entity]="entity.uiTimeoutSettings"
              (ziroFormsUpdate$)="setExceptionHandlingSettings($event, 'uiTimeoutSettings')"
            ></ziro-call-queue-exception-handling-form>
          </ng-template>
        </li>
        <li [ngbNavItem]="ExceptionHandlingSectionType.NO_AGENTS" [destroyOnHide]="false" class="col-4">
          <a ngbNavLink class="btn nav-link text-center" data-automation="exception-handling-no-agents-tab">
            @if (
              exceptionTabsValidationState[ExceptionHandlingSectionType.NO_AGENTS]() ===
              ZiroFormsValidationState.INVALID
            ) {
              <i [class]="ZiroIcons.EXCLAMATION + ' fa fa-md icon-exclamation text-danger'"></i>
            }
            <span>{{ 'tkey;teams_call_queue.exception_handling.no_agents.header' | translate }}</span>
          </a>
          <ng-template ngbNavContent>
            <ziro-call-queue-exception-handling-form
              #noAgentsForm
              [dataAutomation]="'call-queue-no-agents-handling'"
              [sectionType]="ExceptionHandlingSectionType.NO_AGENTS"
              [tenantId]="callQueueViewSource().tenantId.toString()"
              [agentAlertTime]="formData.agentAlertTime"
              [entity]="entity.uiNoAgentSettings"
              (ziroFormsUpdate$)="setExceptionHandlingSettings($event, 'uiNoAgentSettings')"
            ></ziro-call-queue-exception-handling-form>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="exceptionNav" class="mt-2 tab-content"></div>
    </div>
  </ziro-collapsible-section-card>
</div>

<ng-template #resourceAccountResult let-r="result">
  @let isDisabled = isResourceAccountDisabled(r);
  <div
    class="option-div"
    [ngClass]="{ 'disabled-option': isDisabled }"
    [ngbTooltip]="resourceAccountResultTooltip"
    [disableTooltip]="!isDisabled"
    placement="top"
    tooltipClass="resource-account-typeahead-tooltip"
    [tooltipContext]="{ r }"
    (click)="preventClickOnDisabledOptions($event, r)"
  >
    <span>{{ r.userPrincipalName }}</span>
  </div>
</ng-template>
<ng-template #resourceAccountResultTooltip let-r="r">
  <span [innerHtml]="getOptionTooltip(r) | escapeHtml" [style]="tooltipStyles"></span>
</ng-template>

<ng-template #callingIdResourceAccountResult let-r="result">
  @let isDisabled = isCallingIdResourceAccountDisabled(r);
  <div
    class="option-div"
    [ngClass]="{ 'disabled-option': isDisabled }"
    [ngbTooltip]="callingIdResourceAccountResultTooltip"
    [disableTooltip]="!isDisabled"
    placement="top"
    tooltipClass="resource-account-typeahead-tooltip"
    [tooltipContext]="{ r }"
    (click)="preventClickOnCallingIdDisabledOptions($event, r)"
  >
    <span>{{ r.userPrincipalName }}</span>
  </div>
</ng-template>
<ng-template #callingIdResourceAccountResultTooltip let-r="r">
  <span [innerHtml]="getCallingIdOptionTooltip(r) | escapeHtml" [style]="tooltipStyles"></span>
</ng-template>
